import { Button, ButtonStyles, Icons, SelectList } from '@silverfort/sf-components';
import React from 'react';

export const INSIGHT_GRAPH_FILTER_OPTIONS = [
    {
        value: 30,
        title: 'Last Month'
    },
    {
        value: 90,
        title: 'Last 3 Months'
    },
    {
        value: 180,
        title: 'Last 6 Months'
    }
];

const InsightGraphFilter = ({ selectedOption, onChange }) => {
    return (
        <SelectList
            TriggerComponent={Button}
            items={INSIGHT_GRAPH_FILTER_OPTIONS}
            menuClassName="w-[144px]"
            menuProps={{
                disableAutoFocus: true
            }}
            onChange={onChange}
            triggerProps={{
                // @ts-ignore
                text: (
                    <div className="text-sf-gray-800 text-13 font-sf font-normal">
                        {INSIGHT_GRAPH_FILTER_OPTIONS.find((option) => option.value === selectedOption)?.title}
                    </div>
                ),
                className: 'w-[144px] h-full bg-sf-gray-50 border-none',
                iconRight: Icons.ChevronDown,
                buttonStyle: ButtonStyles.Ghost
            }}
        />
    );
};

export default InsightGraphFilter;
